module.exports = __webpack_public_path__ + "img/FatcatGameStudio2.75499391.png";